let renderData = null;

const setRenderData = (data) => {
    renderData = data;
}

const getRenderData = () => {
    return renderData;
}

const isRenderData = () => {
    return !!renderData;
}

const getInstitutionalStates = (renderVar, pureData) => {
    const data = RenderService.getRenderData();

    if (!(data && data[renderVar] && data[renderVar].acf)) {
        return {};
    }

    const renderData = data[renderVar];

    if(pureData) return renderData;

    return {
        content: renderData.acf.content ? renderData.acf.content : null
    }
}

const RenderService = {
    setRenderData,
    getRenderData,
    isRenderData,
    getInstitutionalStates
}

export default RenderService;
